import React from 'react';
import { Row, Col, Form, Table, Button, InputGroup } from 'react-bootstrap';

import { BsTrash, BsPlusCircle } from 'react-icons/bs'; // Make sure these are imported
import { useNavigate } from "react-router-dom";


const MaleForm = ({ form, handleFormChange, rows, setRows, onSubmit, crnDisabled, onDobChange, handleMaleAgeChange, isSubmitting }) => {

    const today = new Date().toISOString().split("T")[0];
    const emptyRow = {
        assay_date: today,
        FSH: "",
        LH: "",
        Testosterone: "",
        Prolactin: "",
        FT4: "",
        FT3: "",
        TSH: ""
    };

    const navigate = useNavigate();

    // const [rows, setRows] = useState([{ ...emptyRow }]);

    const handleRowChange = (index, field, value) => {
        const updated = [...rows];
        updated[index][field] = value;
        setRows(updated);
    };

    const addRow = () => setRows([...rows, { ...emptyRow }]);

    // const addRow = () => {
    //     setRows([...rows, { ...emptyRow }]);
    // };

    const deleteRow = (index) => {
        const updated = rows.filter((_, i) => i !== index);
        setRows(updated.length ? updated : [{ ...emptyRow }]);
    };

    // const handleSubmit = (e) => {
    //     e.preventDefault();
    //     console.log("Form Submitted:", form);
    //     console.log("Hormonal Rows:", rows);
    // };

    return (
        <div className="male-sticky-header">
            <Form>
                <h5 className="mt-3"><b> Male Partner Data</b></h5>
                <Row className="mb-3">
                    <Col md={12} lg={4} xs={12}>
                        <Form.Label>CRN No</Form.Label>
                        <Form.Control name="CRN_No" value={form?.CRN_No || ""} onChange={handleFormChange} disabled={crnDisabled} style={{
                            backgroundColor: crnDisabled ? "#e9ecef" : "#fff"
                        }} />
                    </Col>
                    <Col md={12} lg={4} xs={12}>
                        <Form.Label>Patient Name</Form.Label>
                        <Form.Control name="Patient_Name" value={form?.Patient_Name || ""} onChange={handleFormChange} />
                    </Col>
                    <Col md={12} lg={4} xs={12}>
                        <Form.Label>Sample ID</Form.Label>
                        <Form.Control name="sample_id" value={form?.sample_id || ""} onChange={handleFormChange}   
                            style={{ background: "hsla(120, 24%, 89%, 1.00)", fontWeight: "bold" }} />
                    </Col>
                </Row>

                <Row className="mb-3">
                    <Col md={12} lg={4} xs={12} className="gy-4">
                        <Form.Label>Date of Birth / Age</Form.Label>

                        <InputGroup>
                            {/* DOB */}
                            <Form.Control
                                type="date"
                                value={form?.dob || ""}
                                onChange={(e) => onDobChange(e.target.value)}
                                style={{ fontSize: "13px" }}
                            />

                            {/* Age label */}
                            <InputGroup.Text className="percent-text">Age(Yrs)</InputGroup.Text>

                            {/* Age */}
                            <Form.Control   type="text"
                                value={form?.Age || ""}
                                onChange={handleMaleAgeChange}
                                style={{
                                    maxWidth: "80px",
                                    textAlign: "center",
                                    fontSize: "13px"
                                }}
                            />
                        </InputGroup>
                    </Col>

                    <Col md={12} lg={4} className="gy-4">
                        <Form.Label>Education</Form.Label>
                        <Form.Control name="Education" value={form.Education} onChange={handleFormChange} />
                    </Col>
                    <Col md={12} lg={4} className="gy-4">
                        <Form.Label>Occupation</Form.Label>
                        <Form.Control name="Occupation" value={form.Occupation} onChange={handleFormChange} />
                    </Col>

                    {[
                        {
                            key: "Smoking",
                            label: "Smoking",
                            options: [
                                { value: 1, label: "No" },
                                { value: 2, label: "Former Smoker" },
                                { value: 3, label: "Current Smoker (Daily)" },
                                { value: 4, label: "Current Smoker (Occasional)" },
                                { value: 5, label: "Data Not Available" },
                            ],
                        },
                        {
                            key: "Chewing_Tobacco", // Changed field name
                            label: "Chewing Tobacco",
                            options: [
                                { value: 1, label: "No" },
                                { value: 2, label: "Former User" },
                                { value: 3, label: "Current User (Active)" },
                                { value: 4, label: "Current User (Occasional)" },
                                { value: 5, label: "Data Not Available" },
                            ],
                        },
                        {
                            key: "Alcohol",
                            label: "Alcohol",
                            options: [
                                { value: 1, label: "No" },
                                { value: 2, label: "Former Drinker" },
                                { value: 3, label: "Current Drinker (Active)" },
                                { value: 4, label: "Current Drinker (Occasional)" },
                                { value: 5, label: "Data Not Available" },
                            ],
                        },
                    ].map(({ key, label, options }) => (
                        <Col md={12} lg={4} key={key} className="gy-4">
                            <Form.Label>{label}</Form.Label>
                            <Form.Select name={key} value={form[key]} onChange={handleFormChange}>
                                <option value="">Select</option>
                                {options.map((opt) => (
                                    <option key={opt.value} value={opt.value}>
                                        {opt.label}
                                    </option>
                                ))}
                            </Form.Select>
                        </Col>
                    ))}

                </Row>

                <h6><b>Medical History</b></h6>

                {/* <Row className="mb-3 gy-4">
                    {[
                        ["Diabetes", "Diabetes"],
                        ["Hypertension", "Hypertension"],
                        ["Mumps", "Mumps"],
                        ["Trauma", "Trauma"],
                        ["Surgeries", "Surgeries"],
                        ["Hernia", "Hernia"],
                        ["Undescended_Testes", "Undescended Testes"],
                        ["Varicocele", "Varicocele"],
                        ["Vasectomy", "Vasectomy"],
                        ["STD_Genital_Discharges", "STD / Genital Discharges"]
                    ].map(([key, label]) => (
                        <Col md={12} lg={4} key={key}>
                            <Form.Label>{label}</Form.Label>
                            <Form.Select name={key} value={form[key]} onChange={handleFormChange}>

                                <option value="1">Yes</option>
                                <option value="0">No</option>
                                <option value="2">Data Not Available</option>
                            </Form.Select>
                        </Col>
                    ))} */}
                <Row className="mb-3 gy-4">
                    {/* Diabetes */}
                    <Col md={12} lg={4}>
                        <Form.Label>Diabetes</Form.Label>
                        <Form.Select
                            name="Diabetes"
                            value={form.Diabetes || ""}
                            onChange={handleFormChange}
                        >
                            <option value="" disabled>
                                Select
                            </option>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                            <option value="2">Data Not Available</option>
                        </Form.Select>

                        {form.Diabetes === "1" && (
                            <div className="mt-2">
                                <Form.Control
                                    type="text"
                                    placeholder="Type"
                                    name="Diabetes_Type"
                                    value={form.Diabetes_Type || ""}
                                    onChange={handleFormChange}
                                    className="mb-2"
                                />
                                <Form.Control
                                    type="text"
                                    placeholder="Duration"
                                    name="Diabetes_Duration"
                                    value={form.Diabetes_Duration || ""}
                                    onChange={handleFormChange}
                                />
                            </div>
                        )}
                    </Col>

                    {/* Hypertension */}
                    <Col md={12} lg={4}>
                        <Form.Label>Hypertension</Form.Label>
                        <Form.Select
                            name="Hypertension"
                            value={form.Hypertension || ""}
                            onChange={handleFormChange}
                        >
                            <option value="" disabled>
                                Select
                            </option>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                            <option value="2">Data Not Available</option>
                        </Form.Select>

                        {form.Hypertension === "1" && (
                            <div className="mt-2">
                                <Form.Control
                                    type="text"
                                    placeholder="Duration"
                                    name="Hypertension_Duration"
                                    value={form.Hypertension_Duration || ""}
                                    onChange={handleFormChange}
                                />
                            </div>
                        )}
                    </Col>

                    {/* Other fields */}
                    {[
                        ["Mumps", "Mumps"],
                        ["Trauma", "Trauma"],
                        ["Surgeries", "Surgeries"],
                        ["Hernia", "Hernia"],
                        ["Undescended_Testes", "Undescended Testes"],
                        ["Varicocele", "Varicocele"],
                        ["Vasectomy", "Vasectomy"],
                        ["STD_Genital_Discharges", "STD / Genital Discharges"]
                    ].map(([key, label]) => (
                        <Col md={12} lg={4} key={key}>
                            <Form.Label>{label}</Form.Label>
                            <Form.Select name={key} value={form[key] || ""} onChange={handleFormChange}>
                                <option value="" disabled>
                                    Select
                                </option>
                                <option value="1">Yes</option>
                                <option value="0">No</option>
                                <option value="2">Data Not Available</option>
                            </Form.Select>
                        </Col>
                    ))}


                    <Col md={12} lg={4}>
                        <Form.Label>Genetic Conditions</Form.Label>
                        <Form.Control name="Genetic_Conditions" value={form.Genetic_Conditions} onChange={handleFormChange} />
                    </Col>

                    <Col md={12} lg={4}>
                        <Form.Label>Other Remarks</Form.Label>
                        <Form.Control name="Others" as="textarea" rows={1} value={form.Others} onChange={handleFormChange} />
                    </Col>
                </Row>


                <h6><b>Sexual History </b></h6>
                <Row className="mb-3 gy-4">


                    {[
                        ["execfile_dysfunction", "Erectile Dysfunction"],
                        ["pre_mature_ejaculation", "Premature Ejaculation"],

                    ].map(([key, label]) => (
                        <Col md={12} lg={4} key={key}>
                            <Form.Label>{label}</Form.Label>
                            <Form.Select name={key} value={form[key]} onChange={handleFormChange}>

                                <option value="1">Yes</option>
                                <option value="0">No</option>
                                <option value="2">Data Not Available</option>
                            </Form.Select>
                        </Col>
                    ))}
                </Row>
                <h6><b>Examination</b></h6>
                <Row className="mb-3 gy-4">
                    <Col md={6}>
                        <Form.Label>General Examination</Form.Label>
                        <Form.Control type='text' name="General_Examination" value={form.General_Examination} onChange={handleFormChange} />
                    </Col>
                    <Col md={6}>
                        <Form.Label>Local Examination</Form.Label>
                        <Form.Control type='text' name="Local_Examination" value={form.Local_Examination} onChange={handleFormChange} />
                    </Col>
                </Row>

                <h6><b>Investigation</b></h6>

                <Row className="mb-3 gy-4">

                    {/* Blood Group */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>
                            Blood Group
                        </Form.Label>

                        <Form.Select
                            name="Blood_Group"
                            value={form.Blood_Group || ""}
                            onChange={handleFormChange}

                        >
                            <option value="" disabled>
                                Select blood group
                            </option>

                            {/* Modern concise labels */}
                            <option value="A+">A+</option>
                            <option value="A-">A−</option>

                            <option value="B+">B+</option>
                            <option value="B-">B−</option>

                            <option value="AB+">AB+</option>
                            <option value="AB-">AB−</option>

                            <option value="O+">O+</option>
                            <option value="O-">O−</option>

                            <option value="NA">Not available</option>
                        </Form.Select>
                    </Col>


                    {/* Blood Sugar Random */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Blood Glucose (Random)</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Blood_Sugar_R" min={0} step="0.1"
                                value={form.Blood_Sugar_R || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">mg/dl</InputGroup.Text>
                        </InputGroup>
                    </Col>

                    {/* Blood Sugar Fasting */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Blood Glucose (Fasting)</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text" min={0} step="0.1"
                                name="Blood_Sugar_F"
                                value={form.Blood_Sugar_F || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">mg/dl</InputGroup.Text>
                        </InputGroup>
                    </Col>

                    {/* Blood Sugar PP */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Blood Glucose(Post-Prandial)</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text" min={0} step="0.1"
                                name="Blood_Sugar_PP"
                                value={form.Blood_Sugar_PP || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">mg/dl</InputGroup.Text>
                        </InputGroup>
                    </Col>

                    {/* USG Doppler */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>USG Doppler</Form.Label>
                        <Form.Control
                            type="text"
                            name="USG_Doppler"
                            value={form.USG_Doppler || ""}
                            onChange={handleFormChange}
                        />
                    </Col>

                    {/* Karyotyping Analysis */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Karyotyping Analysis</Form.Label>
                        <Form.Control
                            type="text"
                            name="Karyotyping_Analysis"
                            value={form.Karyotyping_Analysis || ""}
                            onChange={handleFormChange}
                        />
                    </Col>

                    {/* Testicular Biopsy */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Testicular Biopsy</Form.Label>
                        <Form.Control
                            type="text"
                            name="Testicular_Biopsy"
                            value={form.Testicular_Biopsy || ""}
                            onChange={handleFormChange}
                        />
                    </Col>

                    {/* Urologist Opinion */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Urologist Opinion</Form.Label>
                        <Form.Control
                            type="text"
                            name="Urologist_Opinion"
                            value={form.Urologist_Opinion || ""}
                            onChange={handleFormChange}
                        />
                    </Col>



                    {/* Hb Electrophoresis */}
                    {/* <Col xs={12} md={2}>
                        <Form.Label>
                            HbA<sub>1</sub>C
                        </Form.Label>
                        <Form.Select
                            name="Hb_Electrophoresis"
                            value={form.Hb_Electrophoresis || ""}
                            onChange={handleFormChange}
                        >
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </Form.Select>
                    </Col> */}
                    {/* HbA1C Remark */}
                    <Col xs={12} md={4}>
                        <Form.Label>
                            HbA<sub>1</sub>C
                        </Form.Label>
                        <Form.Control
                            as="textarea" rows={1}
                            name="Hb_Remark"
                            value={form.Hb_Remark || ""}
                            onChange={handleFormChange}
                        />
                    </Col>
                    {/* HBsAg */}
                    {/* <Col xs={12} md={4}>
                        <Form.Label>HBsAg</Form.Label>
                        <Form.Select
                            name="HBsAg"
                            value={form.HBsAg || ""}
                            onChange={handleFormChange}
                        >
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </Form.Select>
                    </Col> */}
                    <Col xs={12} md={4}>
                        <Form.Label>
                            <Form.Label>HBsAg</Form.Label>
                        </Form.Label>
                        <Form.Control
                            as="textarea" rows={1}
                            name="ag_Remark"
                            value={form.ag_Remark || ""}
                            onChange={handleFormChange}
                        />
                    </Col>

                    {/* Others */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Others (any)</Form.Label>
                        <Form.Control
                            as="textarea" rows={1}
                            name="Others_any"
                            value={form.Others_any || ""}
                            onChange={handleFormChange}
                        />
                    </Col>

                </Row>

                {/* //////////////////////////////////////////new requested modifications menu ////////////////// */}

                <h6><b>Liver Function Tests</b></h6>

                <Row className="mb-3 gy-4">




                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>ALT</Form.Label>

                        <InputGroup>


                            <Form.Control
                                  type="text"
                                name="ALT"
                                value={form.ALT || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">u/l</InputGroup.Text>
                        </InputGroup>
                    </Col>


                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>ALP</Form.Label>  <InputGroup>
                            <Form.Control
                                  type="text"
                                name="ALP"
                                value={form.ALP || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">u/l</InputGroup.Text>
                        </InputGroup>
                    </Col>

                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>AST</Form.Label>  <InputGroup>
                            <Form.Control
                                  type="text"
                                name="AST"
                                value={form.AST || ""}
                                onChange={handleFormChange}
                            />   <InputGroup.Text className="percent-text">u/l</InputGroup.Text>
                        </InputGroup>
                    </Col>


                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>AST:ALT</Form.Label>  <InputGroup>
                            <Form.Control
                                  type="text"
                                name="AST_ALT"
                                value={form.AST_ALT || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">u/l</InputGroup.Text>
                        </InputGroup>
                    </Col>
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>GGT</Form.Label>  <InputGroup>
                            <Form.Control
                                  type="text"
                                name="GTT"
                                value={form.GTT || ""}
                                onChange={handleFormChange}
                            />    <InputGroup.Text className="percent-text">u/l</InputGroup.Text>
                        </InputGroup>
                    </Col>


                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Total Bilirubin</Form.Label>
                        <InputGroup>   <Form.Control
                              type="text"
                            name="Total_Bilirubin"
                            value={form.Total_Bilirubin || ""}
                            onChange={handleFormChange}
                        />
                            <InputGroup.Text className="percent-text">mg/dl</InputGroup.Text>
                        </InputGroup>
                    </Col>
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Direct Bilirubin</Form.Label> <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Direct_Bilirubin"
                                value={form.Direct_Bilirubin || ""}
                                onChange={handleFormChange}
                            /> <InputGroup.Text className="percent-text">mg/dl</InputGroup.Text>
                        </InputGroup>
                    </Col>


                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Indirect Bilirubin</Form.Label> <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Indirect_Bilirubin"
                                value={form.Indirect_Bilirubin || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">mg/dl</InputGroup.Text>
                        </InputGroup>
                    </Col>
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Total Plasma Protein</Form.Label>
                        <InputGroup>   <Form.Control
                              type="text"
                            name="Total_Plastma_Protein"
                            value={form.Total_Plastma_Protein || ""}
                            onChange={handleFormChange}
                        /> <InputGroup.Text className="percent-text">g/dl</InputGroup.Text>
                        </InputGroup>
                    </Col>


                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Albumin</Form.Label> <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Albumin"
                                value={form.Albumin || ""}
                                onChange={handleFormChange}
                            /><InputGroup.Text className="percent-text">g/dl</InputGroup.Text>
                        </InputGroup>

                    </Col>
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Globulin</Form.Label> <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Globulin"
                                value={form.Globulin || ""}
                                onChange={handleFormChange}
                            /> <InputGroup.Text className="percent-text">g/dl</InputGroup.Text>
                        </InputGroup>
                    </Col>


                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Albumin/Globulin Ratio</Form.Label>
                        <Form.Control
                            type="text"
                            name="Albumin_Globulin_Ratio"
                            value={form.Albumin_Globulin_Ratio || ""}
                            onChange={handleFormChange}
                        />

                    </Col>
                    {/* Others */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Remark</Form.Label>
                        <Form.Control
                            as="textarea" rows={1}
                            name="Liver_Test_remark"
                            value={form.Liver_Test_remark || ""}
                            onChange={handleFormChange}
                        />
                    </Col>

                </Row>
                {/* ///////////////////////////////////Lipid Profile////////////////////////////////////// */}

                <h6><b>Lipid Profile</b></h6>

                <Row className="mb-3 gy-4">

                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Total Cholesterol</Form.Label> <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Total_Cholesterol"
                                value={form.Total_Cholesterol || ""}
                                onChange={handleFormChange}
                            />  <InputGroup.Text className="percent-text">mg/dl</InputGroup.Text>
                        </InputGroup>
                    </Col>
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>LDL Cholesterol</Form.Label> <InputGroup>
                            <Form.Control
                                  type="text"
                                name="LDL_Cholesterol"
                                value={form.LDL_Cholesterol || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">mg/dl</InputGroup.Text>
                        </InputGroup>
                    </Col>
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>HDL Cholesterol</Form.Label> <InputGroup>
                            <Form.Control
                                  type="text"
                                name="HDL_Cholesterol"
                                value={form.HDL_Cholesterol || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">mg/dl</InputGroup.Text>
                        </InputGroup>
                    </Col>
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>VLDL Cholesterol</Form.Label> <InputGroup>
                            <Form.Control
                                  type="text"
                                name="VLDL_Cholesterol"
                                value={form.VLDL_Cholesterol || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">mg/dl</InputGroup.Text>
                        </InputGroup>
                    </Col>
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Triglycerides</Form.Label> <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Triglycerides"
                                value={form.Triglycerides || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">mg/dl</InputGroup.Text>
                        </InputGroup>
                    </Col>
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Total cholesterol to HDL ratio</Form.Label>
                        <Form.Control
                            type="text"
                            name="Total_cholesterol_HDL_ratio"
                            value={form.Total_cholesterol_HDL_ratio || ""}
                            onChange={handleFormChange}
                        />

                    </Col>
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>LDL to HDL ratio</Form.Label>
                        <Form.Control
                            type="text"
                            name="LDL_to_HDL_ratio"
                            value={form.LDL_to_HDL_ratio || ""}
                            onChange={handleFormChange}
                        />

                    </Col>

                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Non HDL cholesterol</Form.Label> <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Non_HDL_cholesterol"
                                value={form.Non_HDL_cholesterol || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">mg/dl</InputGroup.Text>
                        </InputGroup>
                    </Col>

                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Remark</Form.Label>
                        <Form.Control
                            as="textarea" rows={1}
                            name="Lipid_Profile_remark"
                            value={form.Lipid_Profile_remark || ""}
                            onChange={handleFormChange}
                        />
                    </Col>



                </Row>

                {/* //////////////////////////////////////////////////Body Composition Analysis/////////////// */}

                <h6><b>Body Composition Analysis</b></h6>

                <Row className="mb-3 gy-4">




                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Total Body Water</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Total_Body_Water"
                                value={form.Total_Body_Water || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">Litre</InputGroup.Text>
                        </InputGroup>
                    </Col>
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Protein</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Protein"
                                value={form.Protein || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">Kg</InputGroup.Text>
                        </InputGroup>
                    </Col>
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Minerals</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Minerals"
                                value={form.Minerals || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">kg</InputGroup.Text>
                        </InputGroup>
                    </Col>


                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Body Fat Mass</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Body_Fat_Mass"
                                value={form.Body_Fat_Mass || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">kg</InputGroup.Text>
                        </InputGroup>
                    </Col>

                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Soft Lean Mass</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Soft_Lean_Mass"
                                value={form.Soft_Lean_Mass || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">kg</InputGroup.Text>
                        </InputGroup>
                    </Col>
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Fat Free Mass</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Fat_Free_Mass"
                                value={form.Fat_Free_Mass || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">kg</InputGroup.Text>
                        </InputGroup>
                    </Col>
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Body Weight</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Body_Weight"
                                value={form.Body_Weight || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">kg</InputGroup.Text>
                        </InputGroup>
                    </Col>
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Height</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Height"
                                value={form.Height || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">cm</InputGroup.Text>
                        </InputGroup>
                    </Col>

                    {/* Others */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Remark</Form.Label>
                        <Form.Control
                            as="textarea" rows={1}
                            name="Body_Composition_remark"
                            value={form.Body_Composition_remark || ""}
                            onChange={handleFormChange}
                        />
                    </Col>

                </Row>
                {/* /////////////////////////////Muscle Fat Analysis/////////////////////////////////////// */}


                <h6><b>Muscle Fat Analysis</b></h6>

                <Row className="mb-3 gy-4">




                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Weight</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Weight"
                                value={form.Weight || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">kg</InputGroup.Text>
                        </InputGroup>
                    </Col>
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Skeletal Muscle Mass(SMM)</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Skeletal_Muscle_Mass"
                                value={form.Skeletal_Muscle_Mass || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">Kg</InputGroup.Text>
                        </InputGroup>
                    </Col>



                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Body Fat Mass</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Body_Fat_Mass_muscle"
                                value={form.Body_Fat_Mass_muscle || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">kg</InputGroup.Text>
                        </InputGroup>
                    </Col>


                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Body Fat Percent</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Body_Fat_Percent"
                                value={form.Body_Fat_Percent || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">%</InputGroup.Text>
                        </InputGroup>
                    </Col>


                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Remark</Form.Label>
                        <Form.Control
                            as="textarea" rows={1}
                            name="Body_muscle_remark"
                            value={form.Body_muscle_remark || ""}
                            onChange={handleFormChange}
                        />
                    </Col>

                </Row>
                {/* /////////////////////////////////////////obesity Analysis///////////////////////////////////////////////////////////////// */}

                <h6><b>Obesity Analysis</b></h6>

                <Row className="mb-3 gy-4">




                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>BMI</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="BMI_Obesity"
                                value={form.BMI_Obesity || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">kg/m<sup>2</sup></InputGroup.Text>
                        </InputGroup>
                    </Col>
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Percent Body Fat(PBF)</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Percent_Body_Fat"
                                value={form.Percent_Body_Fat || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">Kg</InputGroup.Text>
                        </InputGroup>
                    </Col>

                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Remark</Form.Label>
                        <Form.Control
                            as="textarea" rows={1}
                            name="obesity_remark"
                            value={form.obesity_remark || ""}
                            onChange={handleFormChange}
                        />
                    </Col>

                </Row>

                {/* ///////////////////////////////Segmental Lean Analysis////////////////////////////////////// */}
                <h6><b>Segmental Lean Analysis</b></h6>

                <Row className="mb-3 gy-4">

                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Right Arm (Lean Mass kg)</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Right_Arm_Lean_Mass_kg"
                                value={form.Right_Arm_Lean_Mass_kg || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">kg</InputGroup.Text>
                        </InputGroup>
                    </Col>
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Right Arm (Lean Mass %)</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Right_Arm_Lean_Mass_percent"
                                value={form.Right_Arm_Lean_Mass_percent || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">%</InputGroup.Text>
                        </InputGroup>
                    </Col>

                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Right Arm (ECW Ratio)</Form.Label>

                        <Form.Control
                              type="text"
                            name="Right_Arm_ECW_Ratio"
                            value={form.Right_Arm_ECW_Ratio || ""}
                            onChange={handleFormChange}
                        />

                    </Col>

                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Left Arm (Lean Mass kg)</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Left_Arm_Lean_Mass_kg"
                                value={form.Left_Arm_Lean_Mass_kg || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">kg</InputGroup.Text>
                        </InputGroup>
                    </Col>
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Left Arm (Lean Mass %)</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Left_Arm_Lean_Mass_percent"
                                value={form.Left_Arm_Lean_Mass_percent || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">%</InputGroup.Text>
                        </InputGroup>
                    </Col>

                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Left Arm (ECW Ratio)</Form.Label>

                        <Form.Control
                              type="text"
                            name="Left_Arm_ECW_Ratio"
                            value={form.Left_Arm_ECW_Ratio || ""}
                            onChange={handleFormChange}
                        />

                    </Col>


                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Trunk (Lean Mass kg)</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Trunk_Lean_Mass_kg"
                                value={form.Trunk_Lean_Mass_kg || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">kg</InputGroup.Text>
                        </InputGroup>
                    </Col>
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Trunk (Lean Mass %)</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Trunk_Lean_Mass_percent"
                                value={form.Trunk_Lean_Mass_percent || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">%</InputGroup.Text>
                        </InputGroup>
                    </Col>

                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Trunk (ECW Ratio)</Form.Label>

                        <Form.Control
                              type="text"
                            name="Trunk_ECW_Ratio"
                            value={form.Trunk_ECW_Ratio || ""}
                            onChange={handleFormChange}
                        />

                    </Col>

                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Right Leg (Lean Mass kg)</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Right_Leg_Lean_Mass_kg"
                                value={form.Right_Leg_Lean_Mass_kg || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">kg</InputGroup.Text>
                        </InputGroup>
                    </Col>
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Right Leg (Lean Mass %)</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Right_Leg_Lean_Mass_percent"
                                value={form.Right_Leg_Lean_Mass_percent || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">%</InputGroup.Text>
                        </InputGroup>
                    </Col>

                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Right Leg (ECW Ratio)</Form.Label>

                        <Form.Control
                              type="text"
                            name="Right_Leg_ECW_Ratio"
                            value={form.Right_Leg_ECW_Ratio || ""}
                            onChange={handleFormChange}
                        />

                    </Col>

                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Left Leg (Lean Mass kg)</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Left_Leg_Lean_Mass_kg"
                                value={form.Left_Leg_Lean_Mass_kg || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">kg</InputGroup.Text>
                        </InputGroup>
                    </Col>
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Left Leg (Lean Mass %)</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Left_Leg_Lean_Mass_percent"
                                value={form.Left_Leg_Lean_Mass_percent || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">%</InputGroup.Text>
                        </InputGroup>
                    </Col>

                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Left Leg (ECW Ratio)</Form.Label>

                        <Form.Control
                              type="text"
                            name="Left_Leg_ECW_Ratio"
                            value={form.Left_Leg_ECW_Ratio || ""}
                            onChange={handleFormChange}
                        />

                    </Col>


                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Remark</Form.Label>
                        <Form.Control
                            as="textarea" rows={1}
                            name="Segmental_remark"
                            value={form.Segmental_remark || ""}
                            onChange={handleFormChange}
                        />
                    </Col>

                </Row>
                {/* ///////////////////////////////Segmental Fat Analysis////////////////////////////////////// */}
                <h6><b>Segmental Fat Analysis</b></h6>

                <Row className="mb-3 gy-4">

                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Right Arm (Fat Mass Kg)</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Right_Arm_Fat_Mass_kg"
                                value={form.Right_Arm_Fat_Mass_kg || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">kg</InputGroup.Text>
                        </InputGroup>
                    </Col>
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Right Arm (Fat Mass %)</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Right_Arm_Fat_Mass_percent"
                                value={form.Right_Arm_Fat_Mass_percent || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">%</InputGroup.Text>
                        </InputGroup>
                    </Col>



                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Left Arm (Fat Mass kg)</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Left_Arm_Fat_Mass_kg"
                                value={form.Left_Arm_Fat_Mass_kg || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">kg</InputGroup.Text>
                        </InputGroup>
                    </Col>
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Left Arm (Fat Mass %)</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Left_Arm_Fat_Mass_percent"
                                value={form.Left_Arm_Fat_Mass_percent || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">%</InputGroup.Text>
                        </InputGroup>
                    </Col>




                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Trunk (Fat Mass kg)</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Trunk_Fat_Mass_kg"
                                value={form.Trunk_Fat_Mass_kg || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">kg</InputGroup.Text>
                        </InputGroup>
                    </Col>
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Trunk (Fat Mass %)</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Trunk_Fat_Mass_percent"
                                value={form.Trunk_Fat_Mass_percent || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">%</InputGroup.Text>
                        </InputGroup>
                    </Col>



                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Right Leg (Fat Mass kg)</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Right_Leg_Fat_Mass_kg"
                                value={form.Right_Leg_Fat_Mass_kg || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">kg</InputGroup.Text>
                        </InputGroup>
                    </Col>
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Right Leg (Fat Mass %)</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Right_Leg_Fat_Mass_percent"
                                value={form.Right_Leg_Fat_Mass_percent || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">%</InputGroup.Text>
                        </InputGroup>
                    </Col>


                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Left Leg (Fat Mass kg)</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Left_Leg_Fat_Mass_kg"
                                value={form.Left_Leg_Fat_Mass_kg || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">kg</InputGroup.Text>
                        </InputGroup>
                    </Col>
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Left Leg (Fat Mass %)</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Left_Leg_Fat_Mass_percent"
                                value={form.Left_Leg_Fat_Mass_percent || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">%</InputGroup.Text>
                        </InputGroup>
                    </Col>




                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Remark</Form.Label>
                        <Form.Control
                            as="textarea" rows={1}
                            name="Segmental_fat_remark"
                            value={form.Segmental_fat_remark || ""}
                            onChange={handleFormChange}
                        />
                    </Col>

                </Row>
                {/* //////////////////////////////////////Miscellaneous //////////////////////////////////////////////////////////// */}
                <h6><b>Miscellaneous</b></h6>

                <Row className="mb-3 gy-4">

                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>In Body Score</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="In_Body_Score"
                                value={form.In_Body_Score || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">100<sup>Points</sup></InputGroup.Text>
                        </InputGroup>
                    </Col>
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Visceral Fat Area</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Visceral_Fat_Area"
                                value={form.Visceral_Fat_Area || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">cm<sup>2</sup></InputGroup.Text>
                        </InputGroup>
                    </Col>



                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Whole Body Phase Angle</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Whole_Body_Phase_Angle"
                                value={form.Whole_Body_Phase_Angle || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text"><sup>o</sup></InputGroup.Text>
                        </InputGroup>
                    </Col>
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Intracellular Water</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Intracellular_Water"
                                value={form.Intracellular_Water || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">Litre</InputGroup.Text>
                        </InputGroup>
                    </Col>




                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Extracellular Water</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Extracellular_Water"
                                value={form.Extracellular_Water || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">Litre</InputGroup.Text>
                        </InputGroup>
                    </Col>
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Basal Metabolic Rate</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Basal_Metabolic_Rate"
                                value={form.Basal_Metabolic_Rate || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">kcal</InputGroup.Text>
                        </InputGroup>
                    </Col>

                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>SMI (Sarcopenia)</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="SMI_Sarcopenia"
                                value={form.SMI_Sarcopenia || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">kg/m<sup>2</sup></InputGroup.Text>
                        </InputGroup>
                    </Col>


                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>HGS (Sarcopenia)</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="HGS_Sarcopenia"
                                value={form.HGS_Sarcopenia || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">kg</InputGroup.Text>
                        </InputGroup>
                    </Col>




                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Remark</Form.Label>
                        <Form.Control
                            as="textarea" rows={1}
                            name="Miscellaneous_remark"
                            value={form.Miscellaneous_remark || ""}
                            onChange={handleFormChange}
                        />
                    </Col>

                </Row>
                {/* ///////////////////////////////////////////END//////////////////////////////////////////////// */}


                <h6><b>Hormonal Assay</b></h6>

                <Table bordered responsive>
                    <thead style={{ background: "#1a3d7c", color: "#fff" }}>
                        <tr>
                            <th>Sr</th>
                            <th>Date</th>
                            <th>FSH</th>
                            <th>LH</th>
                            <th>Testosterone</th>
                            <th>Prolactin</th>
                            <th>FT4</th>
                            <th>FT3</th>
                            <th>TSH</th>
                            <th className="text-center">
                                <Button variant="success" size="sm" onClick={addRow}>
                                    <BsPlusCircle />
                                </Button>
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        {rows.map((row, i) => (
                            <tr key={i}>
                                <td>{i + 1}</td>

                                <td>
                                    <Form.Control
                                        type="date"
                                        value={row.assay_date}
                                        onChange={(e) =>
                                            handleRowChange(i, "assay_date", e.target.value)
                                        }
                                    />
                                </td>

                                {["FSH", "LH", "Testosterone", "Prolactin", "FT4", "FT3", "TSH"].map((field) => (
                                    <td key={field}>
                                        <Form.Control
                                              type="text"
                                           
                                            value={row[field]}
                                            onChange={(e) =>
                                                handleRowChange(i, field, e.target.value)
                                            }
                                        />
                                    </td>
                                ))}

                                <td className="text-center">
                                    <Button
                                        variant="danger"
                                        size="sm"
                                        onClick={() => deleteRow(i)}
                                        disabled={rows.length === 1}
                                    >
                                        <BsTrash />
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>




                <h6 className="mt-4"><b>Semen Analysis</b></h6>
                <h6 className="mt-4"><b>Pre-Preparation</b></h6>
                <Row className="mb-3 gy-4">

                    {/* Date of Sample Collection */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Date of Sample Collection</Form.Label>
                        <Form.Control
                            type="date"
                            name="Date_of_Sample"
                            value={form.Date_of_Sample || ""}
                            onChange={handleFormChange}
                        />
                    </Col>

                    {/* Ejaculatory Abstinence */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Ejaculatory Abstinence</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Ejaculatory_Abstinence"
                                value={form.Ejaculatory_Abstinence || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">days</InputGroup.Text>
                        </InputGroup>
                    </Col>

                    {/* Semen Volume */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Semen Volume</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Semen_Volume"
                                value={form.Semen_Volume || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">ml</InputGroup.Text>
                        </InputGroup>
                    </Col>

                    {/* Color / Appearance */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Color</Form.Label>
                        <Form.Control
                            type="text"
                            name="Color"
                            value={form.Color || ""}
                            onChange={handleFormChange}
                        />
                    </Col>

                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Appearance</Form.Label>
                        <Form.Control
                            type="text"
                            name="Appearance"
                            value={form.Appearance || ""}
                            onChange={handleFormChange}
                        />
                    </Col>


                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Liquefaction Time</Form.Label>

                        <InputGroup className="align-items-center">
                            <Form.Control
                                  type="text"
                                name="Liquifcation_Time"
                                value={form.Liquifcation_Time || ""}
                                onChange={handleFormChange}
                                onInput={(e) => (e.target.value = e.target.value.slice(0, 2))}
                                placeholder="00"
                                style={{
                                    maxWidth: "75px",
                                    textAlign: "center",
                                }}
                            />

                            <InputGroup.Text className="percent-text">min</InputGroup.Text>

                            <Form.Control
                                type="text"
                                name="Liquifcation_Remark"
                                value={form.Liquifcation_Remark || ""}
                                onChange={handleFormChange}
                                maxLength={6}
                                placeholder="enter remark"
                                style={{
                                    maxWidth: "220px",
                                    textAlign: "center",
                                }}
                            />
                        </InputGroup>
                    </Col>



                    {/* Viscosity */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Viscosity</Form.Label>
                        <Form.Control
                            type="text"
                            name="Viscosity"
                            value={form.Viscosity || ""}
                            onChange={handleFormChange}
                        />
                    </Col>

                    {/* pH */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>pH</Form.Label>
                        <Form.Control
                              type="text"
                            name="pH"
                            value={form.pH || ""}
                            onChange={handleFormChange}
                        />
                    </Col>

                    {/* Sperm Concentration */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Sperm Concentration</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Semen_Concentration"
                                value={form.Semen_Concentration || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">million/ml</InputGroup.Text>
                        </InputGroup>
                    </Col>



                    {/* Total Sperm Number */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Total Sperm Number</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Total_Sperm_Count"
                                value={form.Total_Sperm_Count || ""}     
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">million/ejaculate</InputGroup.Text>
                        </InputGroup>
                    </Col>
                    {/* Total Progressive Motile Sperm Count */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Total Progressive Motile Sperm Count</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Count_Motile_Sperm"     
                                value={form.Count_Motile_Sperm || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">million/ejaculate</InputGroup.Text>
                        </InputGroup>
                    </Col>
                    {/* Progressive Motility PR */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Progressive Motility PR</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Progressive_Motility_Rate"
                                value={form.Progressive_Motility_Rate || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">%</InputGroup.Text>
                        </InputGroup>
                    </Col>



                    {/* Non-Progressive Motility */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Non-Progressive Motility</Form.Label>
                        <InputGroup><Form.Control
                              type="text"
                            name="NonP_Motility"
                            value={form.NonP_Motility || ""}
                            onChange={handleFormChange}
                        />
                            <InputGroup.Text className="percent-text">%</InputGroup.Text>
                        </InputGroup>
                    </Col>
                    {/* Total Motility */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Total Motility</Form.Label>
                        <InputGroup>
                            <Form.Control  
                                  type="text"
                                name="Total_Motility"
                                value={form.Total_Motility || ""}   
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">%</InputGroup.Text>
                        </InputGroup>
                    </Col>
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Immotile</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Immotile"
                                value={form.Immotile || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">%</InputGroup.Text>
                        </InputGroup>
                    </Col>


                    {/* Vitality */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Vitality</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Vitality"
                                value={form.Vitality || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">%</InputGroup.Text>
                        </InputGroup>
                    </Col>

                    {/* Normal Sperm Morphology */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Normal Sperm Morphology</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Normal_Sperm_Morphology"
                                value={form.Normal_Sperm_Morphology || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">%</InputGroup.Text>
                        </InputGroup>
                    </Col>

                    {/* Abnormal Heads */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Abnormal Heads</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Abnormal_Heads"
                                value={form.Abnormal_Heads || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">%</InputGroup.Text>
                        </InputGroup>
                    </Col>

                    {/* Abnormal Neck & Midpiece */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Abnormal Neck & Midpiece</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Abnormal_NandM"
                                value={form.Abnormal_NandM || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">%</InputGroup.Text>
                        </InputGroup>
                    </Col>

                    {/* Abnormal Tail */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Abnormal Tail</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Abnormal_Tail"
                                value={form.Abnormal_Tail || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">%</InputGroup.Text>
                        </InputGroup>
                    </Col>

                    {/* Extra Cytoplasmic Residue */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Extra Cytoplasmic Residue</Form.Label>
                        <InputGroup>
                            <Form.Control
                                  type="text"
                                name="Extra_cytoplasmic"
                                value={form.Extra_cytoplasmic || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">%</InputGroup.Text>
                        </InputGroup>
                    </Col>

                    {/* Qualitative Fructose */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Qualitative Fructose</Form.Label>
                        <Form.Control
                            type="text"
                            name="Qualitative_Fructose"
                            value={form.Qualitative_Fructose || ""}
                            onChange={handleFormChange}
                        />
                    </Col>

                    {/* Aggregation */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Aggregation</Form.Label>
                        <Form.Control
                            type="text"
                            name="Aggregation"
                            value={form.Aggregation || ""}
                            onChange={handleFormChange}
                        />
                    </Col>

                    {/* Agglutination */}
                    <Col xs={12} md={3}>
                        <Form.Label>Agglutination</Form.Label>
                        <Form.Control
                            type="text"
                            name="Agglutination"
                            value={form.Agglutination || ""}
                            onChange={handleFormChange}
                        />
                    </Col>
                    <h6 className="mt-4"><b>Post-Preparation</b></h6>

                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Sperm Concentration</Form.Label>
                        <InputGroup>
                            <Form.Control

                                name="Semen_Concentration_post"
                                value={form.Semen_Concentration_post || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">million/ml</InputGroup.Text>
                        </InputGroup>
                    </Col>

                    {/* Total Sperm Number */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Total Sperm count</Form.Label>
                        <InputGroup>
                            <Form.Control

                                name="Total_Sperm_Count_post"
                                value={form.Total_Sperm_Count_post || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">million/sample volume</InputGroup.Text>
                        </InputGroup>
                    </Col>

                    {/* Progressive Motility PR */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Progressive Motility PR</Form.Label>
                        <InputGroup>
                            <Form.Control

                                name="Progressive_Motility_Rate_post"
                                value={form.Progressive_Motility_Rate_post || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">%</InputGroup.Text>
                        </InputGroup>
                    </Col>



                    {/* Non-Progressive Motility */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Non-Progressive Motility</Form.Label>
                        <InputGroup><Form.Control

                            name="NonP_Motility_post"
                            value={form.NonP_Motility_post || ""}
                            onChange={handleFormChange}
                        />
                            <InputGroup.Text className="percent-text">%</InputGroup.Text>
                        </InputGroup>
                    </Col>
                    {/* Total Motility */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Total Motility</Form.Label>
                        <InputGroup>
                            <Form.Control

                                name="handleFormChange_post"
                                value={form.handleFormChange_post || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">%</InputGroup.Text>
                        </InputGroup>
                    </Col>
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Immotile</Form.Label>
                        <InputGroup>
                            <Form.Control

                                name="Immotile_post"
                                value={form.Immotile_post || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">%</InputGroup.Text>
                        </InputGroup>
                    </Col>




                    {/* Normal Sperm Morphology */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Normal Sperm Morphology</Form.Label>
                        <InputGroup>
                            <Form.Control

                                name="Normal_Sperm_Morphology_post"
                                value={form.Normal_Sperm_Morphology_post || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">%</InputGroup.Text>
                        </InputGroup>
                    </Col>

                    {/* Abnormal Heads */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Abnormal Heads</Form.Label>
                        <InputGroup>
                            <Form.Control

                                name="Abnormal_Heads_post"
                                value={form.Abnormal_Heads_post || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">%</InputGroup.Text>
                        </InputGroup>
                    </Col>

                    {/* Abnormal Neck & Midpiece */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Abnormal Neck & Midpiece</Form.Label>
                        <InputGroup>
                            <Form.Control

                                name="Abnormal_NandM_post"
                                value={form.Abnormal_NandM_post || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">%</InputGroup.Text>
                        </InputGroup>
                    </Col>

                    {/* Abnormal Tail */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Abnormal Tail</Form.Label>
                        <InputGroup>
                            <Form.Control

                                name="Abnormal_Tail_post"
                                value={form.Abnormal_Tail_post || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">%</InputGroup.Text>
                        </InputGroup>
                    </Col>

                    {/* Extra Cytoplasmic Residue */}
                    <Col xs={12} md={12} lg={4}>
                        <Form.Label>Extra Cytoplasmic Residue</Form.Label>
                        <InputGroup>
                            <Form.Control

                                name="Extra_cytoplasmic_post"
                                value={form.Extra_cytoplasmic_post || ""}
                                onChange={handleFormChange}
                            />
                            <InputGroup.Text className="percent-text">%</InputGroup.Text>
                        </InputGroup>
                    </Col>

                    {/* ///////////////////end new menu/////////////////// */}
                    {/* Round Cells */}
                    <Col xs={12} md={4}>
                        <Form.Label>Round Cells</Form.Label>
                        <Form.Control
                            type="text"
                            name="Round_Cells"
                            value={form.Round_Cells || ""}
                            onChange={handleFormChange}
                        />
                    </Col>

                    {/* Epithelial Cells */}
                    <Col xs={12} md={4}>
                        <Form.Label>Epithelial Cells</Form.Label>
                        <Form.Control
                            type="text"
                            name="Epithelial_Cells"
                            value={form.Epithelial_Cells || ""}
                            onChange={handleFormChange}
                        />
                    </Col>

                    {/* Other Cells */}
                    <Col xs={12} md={4}>
                        <Form.Label>Other Cells</Form.Label>
                        <Form.Control
                            type="text"
                            name="Other_Cells"
                            value={form.Other_Cells || ""}
                            onChange={handleFormChange}
                        />
                    </Col>
                    <Col xs={12} md={4}>
                        <Form.Label>RSA Report</Form.Label>
                        <Form.Control
                            type="text"
                            name="RSA_Report"
                            value={form.RSA_Report || ""}
                            onChange={handleFormChange}
                        />
                    </Col>

                </Row>




                <Form.Group className="mb-3">
                    <Form.Label>Other Remarks</Form.Label>
                    <Form.Control
                        as="textarea" rows={1}
                        name="Other_Remarks"
                        value={form.Other_Remarks}
                        onChange={handleFormChange}
                    />
                </Form.Group>
                <Row className="justify-content-center mt-4">
                    <Col xs="auto">
                        {/* <Button
                        variant="primary"
                        className="px-4 me-3"
                        onClick={onSubmit}
                    >
                        Submit
                    </Button> */}


                        <button
                            type="button"
                            onClick={onSubmit}   // or any function you already use
                            className="floating-btn px-4 me-3" disabled={isSubmitting}
                        >
                            {isSubmitting ? "Submitting..." : "Save"}
                        </button>

                        <Button
                            variant="outline-secondary"
                            className="px-4"
                            onClick={() => navigate("/Patient_report_sample_id_wise")}
                        >
                            Exit
                        </Button>
                    </Col>
                </Row>
            </Form>
        </div>
    );
};

export default MaleForm;
